import { Download, Home, ClipboardList } from 'lucide-react';
import AnimateIn from './AnimateIn';

const steps = [
  {
    num: '01',
    icon: Download,
    title: 'Download the app',
    desc: 'Get ActCheck from the App Store or Google Play. It takes less than a minute.',
  },
  {
    num: '02',
    icon: Home,
    title: 'Set up your property or tenancy',
    desc: 'Add your property details, tenancy information, and key dates to get started.',
  },
  {
    num: '03',
    icon: ClipboardList,
    title: 'Start tracking everything',
    desc: 'Track documents, reminders, repairs, and next steps. All in one place.',
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-20 sm:py-28 bg-mist">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimateIn>
          <div className="text-center mb-16">
            <span className="inline-block text-compliance-green font-body font-semibold text-sm tracking-wide uppercase mb-3">
              How It Works
            </span>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl text-ink mb-4">
              Get started in three simple steps
            </h2>
          </div>
        </AnimateIn>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((s, i) => (
            <AnimateIn key={s.num} delay={i * 150}>
              <div data-testid={`how-step-${i}`} className="text-center">
                <div className="relative inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-white shadow-lg shadow-navy/5 mb-6">
                  <s.icon size={32} className="text-compliance-green" />
                  <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-navy text-white text-xs font-heading font-bold flex items-center justify-center">
                    {s.num}
                  </span>
                </div>
                <h3 className="font-heading font-bold text-xl text-ink mb-3">{s.title}</h3>
                <p className="font-body text-slate-text text-sm leading-relaxed max-w-xs mx-auto">{s.desc}</p>
              </div>
            </AnimateIn>
          ))}
        </div>

        {/* Connector line - desktop only */}
        <div className="hidden md:block relative mt-[-220px] mb-[140px] mx-auto max-w-3xl">
          <div className="absolute top-1/2 left-[16%] right-[16%] h-[2px] bg-gradient-to-r from-compliance-green/20 via-compliance-green/40 to-compliance-green/20" />
        </div>
      </div>
    </section>
  );
}
